import styled from "@emotion/styled";
import { bounce } from "components/ui/utils/animations";

export const LogoWrapper = styled.div`
  animation: ${bounce} 4s cubic-bezier(0.28, 0.84, 0.42, 1) infinite;
`;
